import { render, staticRenderFns } from "./ChatbotIframe.vue?vue&type=template&id=7bb86055&scoped=true"
import script from "./ChatbotIframe.vue?vue&type=script&lang=js"
export * from "./ChatbotIframe.vue?vue&type=script&lang=js"
import style0 from "./ChatbotIframe.vue?vue&type=style&index=0&id=7bb86055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb86055",
  null
  
)

export default component.exports